webpackJsonpUpdateBris([83],{

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// CONSTANTS are all caps.
var NS = 'VideoAndTextBlock';
var CLS = 'videoTextBlock';
var BLK = '.' + CLS + '-';

var VideoAndTextBlock = exports.VideoAndTextBlock = function () {
	function VideoAndTextBlock($el) {
		_classCallCheck(this, VideoAndTextBlock);

		// $el is the blk node return by the loadVideoFeature function
		this.$el = $el;
		this.enterViewPort = false;
		this.img = $(this.$el).find('.videoTextBlock-thumbnail')[0];
	}

	_createClass(VideoAndTextBlock, [{
		key: 'init',
		value: function init() {
			this.controlsVideo();
			this.imageClick();
		}
	}, {
		key: 'controlsVideo',
		value: function controlsVideo() {
			var _this = this;

			var enterViewPort = this.enterViewPort;
			var video = $(this.$el).find('video')[0];
			var autoPlay = video.getAttribute('data-autoplay');
			if (autoPlay === 'off' || autoPlay === 'video_audio') {
				video.setAttribute('controls', true);
			}
			if (autoPlay === 'video_only' || autoPlay === 'video_audio') {
				var playPromise = video.play();
				if (playPromise !== undefined) {
					playPromise.then(function (_) {
						var observer = new IntersectionObserver(function (entries) {
							entries.forEach(function (entry) {
								if (entry.intersectionRatio !== 1 && !video.paused && !enterViewPort) {
									video.pause();
								} else if (video.paused) {
									if (_this.img) {
										$(_this.img).addClass('d-none');
										$(video).removeClass('d-none');
									}
									video.play();
									enterViewPort = true;
								}
							});
						}, { threshold: 0.75 });
						if (_this.img) {
							observer.observe(_this.img);
						} else {
							observer.observe(video);
						}
					});
				}
			}
		}
	}, {
		key: 'imageClick',
		value: function imageClick() {
			var _this2 = this;

			var $block = $(this.$el);
			var video = $block.find('video')[0];
			$(this.img).on('click', function () {
				$(_this2.img).addClass('d-none');
				$(video).removeClass('d-none');
				video.play();
				video.muted = false;
			});
		}
	}]);

	return VideoAndTextBlock;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1747018470964.blk-video-and-text-block-chunk.js